module.exports = __webpack_public_path__ + "img/logo_socmed.b83aff30.png";